
import { Component, Vue, Prop, Watch, Emit, Mixins } from 'vue-property-decorator'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import { Observer } from 'mobx-vue'
import { MixinsHomeClick } from '@xt/client/mixins/home'

@Observer
@Component({
  components: {
    LazyImg
  }
})
export default class ChooseGuide extends Mixins(MixinsHomeClick) {
  jumpers: Array<{
    name: string
    key: string
  }> = [
    {
      name: 'beginner1',
      key: 'beginner'
    },
    {
      name: 'beginner2',
      key: 'beginner'
    },
    {
      name: 'first1',
      key: 'first'
    },
    {
      name: 'first2',
      key: 'first'
    },
    {
      name: 'second1',
      key: 'second'
    },
    {
      name: 'second2',
      key: 'second'
    },
    {
      name: 'third1',
      key: 'third'
    },
    {
      name: 'third2',
      key: 'third'
    },
    {
      name: 'fourth1',
      key: 'fourth'
    },
    {
      name: 'fourth2',
      key: 'fourth'
    },
    {
      name: 'fifth1',
      key: 'fifth'
    },
    {
      name: 'fifth2',
      key: 'fifth'
    },
    {
      name: 'sixth1',
      key: 'sixth'
    },
    {
      name: 'sixth2',
      key: 'sixth'
    }
  ]

  get PageStore() {
    return this.$store.$storeActivitys.Calligraphy
  }

  toDetail(item: string) {
    const dataSource = this.PageStore.dataSource

    if (!dataSource || !dataSource.guide) return

    const target = dataSource.guide[item]

    if (!target) return

    if (target.event) {
      this.onClickEvent(target.event)
    }
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
